import { type ReactElement } from 'react'
import { Size } from '@front/model'
import { Stack, Group, Text } from '@mantine/core'
import { useTeamHierarchyContext } from 'app/components'
import { ButtonVisibility } from '../ButtonVisibility'
import { type TeamNodeContentProps } from './types'

export const BasicNode = ({ team }: TeamNodeContentProps): ReactElement => {
  const { collapsedTeams, toggleTeamCollapse } = useTeamHierarchyContext()

  const handleToggleVisibility = (): void => {
    toggleTeamCollapse(team.teamId)
  }

  return (
    <Stack>
      <Text className='text-center'>{team.name}</Text>
      <Group gap={Size.space.lg} justify='center' onClick={(e) => e.stopPropagation()}>
        <ButtonVisibility isHiding={collapsedTeams.includes(team.teamId)} onClick={handleToggleVisibility} />
      </Group>
    </Stack>
  )
}
